import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useRemittanceEmails(paymentId: string | undefined) {
  const query = useQuery({
    ...orpc.finance.payments.listRemittanceEmails.queryOptions({
      input: { paymentId: paymentId ?? '' },
    }),
    enabled: !!paymentId,
  });

  return {
    ...query,
    emails: query.data?.emails ?? [],
  };
}
